import React from 'react';

const stats = [
  {
    value: '10%',
    label: "paper warranty registration rate",
    detail: 'Paper cards get lost. Web forms get abandoned. With scan-to-register, that jumps to 35%.',
  },
  {
    value: '£13.50',
    label: 'per phone support call',
    detail: 'AI that knows the product resolves queries for £0.75. Most questions are setup and troubleshooting.',
  },
  {
    value: '23%',
    label: 'of returns are unnecessary',
    detail: 'No fault found. The customer couldn\'t get support, so they sent it back. That\'s a process failure, not a product failure.',
  },
];

export const ProblemStatement: React.FC = () => {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-24 sm:py-32">
      <div className="mx-auto max-w-2xl text-center mb-16">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl" style={{ color: '#241E61' }}>
          70% of your products are never registered
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Warranty is managed by email. Returns are manual. Your customers call a phone queue that starts from scratch every time. You designed a product worth caring about — then handed the entire after-sale relationship to disconnected, frustrating tools.
        </p>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
        {stats.map((stat) => (
          <div
            key={stat.value}
            className="relative rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
          >
            <p className="text-5xl font-bold tracking-tight" style={{ color: '#241E61' }}>
              {stat.value}
            </p>
            <p className="mt-3 text-base font-semibold text-gray-900">
              {stat.label}
            </p>
            <p className="mt-2 text-sm text-gray-500">
              {stat.detail}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
